var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HomeEstimatorRequest } from '../../../services/home-estimator.service';
import { ListingsService } from '../../../services/listings.service';
import { Pagination } from '../../../classes/pagination';
import { Filters } from '../../../classes/user-preferences';
import { CommunicationService } from '../../../services/communication.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { SCREEN_SIZE } from '../../../classes/enums';
import { PreRenderService } from '../../../services/pre-render.service';
var HomeEstimatorEstimateComponent = /** @class */ (function (_super) {
    __extends(HomeEstimatorEstimateComponent, _super);
    function HomeEstimatorEstimateComponent(listingsService, communicationService, prerenderService) {
        var _this = _super.call(this) || this;
        _this.listingsService = listingsService;
        _this.communicationService = communicationService;
        _this.prerenderService = prerenderService;
        _this.onContactAgent = new EventEmitter();
        _this.onEdit = new EventEmitter();
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.mapOptions = {
            zoom: 15,
            zoomControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false
        };
        _this.mapEnabled = !_this.prerenderService.isServerMode;
        return _this;
    }
    HomeEstimatorEstimateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) {
            _this.screenSize = screenSize;
        }));
        this.calculatedEstimate = {
            needsRepair: this.homeEstimate.marketValue * 0.95,
            wellMaintained: this.homeEstimate.marketValue * 1.05,
            showHome: this.homeEstimate.marketValue * 1.07
        };
    };
    HomeEstimatorEstimateComponent.prototype.mapReady = function (map) {
        this.map = map;
    };
    HomeEstimatorEstimateComponent.prototype.mapIdle = function (event) {
        var _this = this;
        if (this.map && this.map.getCenter()) {
            this.listingsService.getListingsByDistanceFrom(new Pagination(), new Filters(), this.map.getCenter().toJSON()).then(function (response) {
                _this.suggestedListings = response.results;
            });
        }
    };
    return HomeEstimatorEstimateComponent;
}(HasSubscriptions));
export { HomeEstimatorEstimateComponent };
